
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/playstation",
      function () {
        return require("private-next-pages/playstation.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/playstation"])
      });
    }
  